// src/pages/documents/RulesFI.js
          //this will be painful to update
import React from 'react';

const RulesEN = () => {
  return (
    <div className="page rules-page">
      <section className="page-header">
        <div className="container">
          <h1>Rules in English</h1>
          <p>Below are the rules of Integralis in English</p>
          <p>(note that the official rules are in Finnish)</p>
        </div>
      </section>

      <section className="content-section">
        <div className="container">

          <div className="rule-card">
            <h3>Rules of the organization</h3>
            <p>
              <h4>Name and Residency</h4>
The name of the association is Integralis ry, and it is based in Helsinki. The official language
of the association is Finnish. However, meetings will be held primarily in English and all
documents must be available in English.

              <h4>2. Purpose and Forms of Activity</h4>
The purpose of the association is to promote the well-being of the students in the bachelor's
Programme in Science at the University of Helsinki as well as international/exchange
students. In following these groups will be referred to as our party of interest. The
association aims to achieve this purpose in the following ways:
<ul>
  <li>Promoting the financial, legal and social interests of our party of interest.</li>
  <li>Organizing events and activities for our party of interest.</li>
  <li>Assisting new students among our party of interest in the beginning of their studies.</li>
  <li>Collaborating with other associations</li>
  <li>Assisting our party of interest in their studies</li>
</ul>

In order to financially support the activities of the association, the association may organize
fundraisers, hold raffles, and sell tickets for events. The association can also accept
sponsorships, donations and testaments. In addition, the association can own physical
property.

              <h4>3. Participation of Integralis ry in Activities of Political Nature</h4>
Integralis ry may participate in explicitly political activities within the boundaries of Finnish
law and HYY stipulations. Integralis is not associated with any political party.

<h4>4. Members</h4>
The board of the association can accept the students at the University of Helsinki in the
faculty of science as official members.
Members from other faculties or outside the University of Helsinki may be accepted as
outside members.
The board may institute mechanisms for approving new members such as electronic
membership registers.
All official members have the right to participate and vote in association (statutory)
meetings.
Outside members can participate in the meetings, but they do not retain the right to vote.<br></br>
The association can charge its members an annual membership fee. The fee is decided upon
in a statutory meeting. The fee can be different for official members and outside members. It
is also possible to pay the membership fee in advance for multiple years at a different rate.
The membership payment period starts on 1.8 and ends on 31.7. of each year.
<br></br>
The board can decide about the dismissing of the member. If the board wants to dismiss a
member, the member must be invited to a meeting where the member can defend
themselves. The board can dismiss a member if 2/3 of the board votes to proceed with the
dismissal. If a member wants to resign from the association, they must inform the board. A
member is dismissed if they haven&#8217;t paid the membership fee for a full membership
payment period. 

<h4>5. The Board of the Association</h4>
The board consists of a president, vice president, secretary, treasurer and at least one and at
most eight other board members, who must be official members of the association. The
president and the vice president of the association must be a student or a former student of
the Bachelor's Programme in Science at the University of Helsinki. The term of the board is
one calendar year. Board members can also resign, but an official association meeting must
be called to fill the position if the board is not functional without them.
The board is responsible for: 
<ul>
  <li>Managing the association according to the law, the rules, guidelines and the meetings of
the association</li>
  <li>Creating drafts for the budget, end of year report, financial statement and action plan
each year
</li>
  <li>Maintaining a list of the members</li>
  <li>Monitoring the association&#8217;s finances</li>
</ul>
The board meetings are called by the president or the vice president. Official decisions can
be made during the board meeting if half of the board is present, including the president or
vice-president. 

<h4>6. Approved Signatory </h4>
The association may be represented by the President, Vice-President, or Treasurer, each
acting individually, or by any two members of the board acting jointly.

<h4>7. Association meetings</h4>
Statutory organization meetings are called by the board of the association, and a meeting
must be called at least a week before the meeting through an email invite.
The association has two official statutory organization meetings each year.
The spring statutory organization meeting is held in February or March. In the meeting, the
budget, financial statement and action plan are approved as well as the membership fee. The
meeting also decides on whether previous board members are freed from their obligations. <br></br>
The fall statutory organization meeting is held in November or December. In the meeting the
board and one or two auditors for the next year are chosen. The budget and action plan for
the next year are confirmed.
Extra statutory organization meetings can be held if at least 1/10 of the official members of
the association wish to do so or if the board considers it necessary.
A meeting has valid proceedings if it is called according to previously mentioned terms. 

<h4>8. Formation Meeting</h4>
Before the 31st of January of the coming year, the incoming board must hold a Formation
meeting.
The Formation meeting is called by the incoming president or the incoming vice president.
Official decisions can be made during the meeting if half of the incoming board is present
including the incoming president or incoming vice-president.<br></br>

If the formation meeting is held before the 1st of January, it is a legal meeting, but only holds
decision making power over deciding board officer positions, the transfer of accounts from
the old to the new board, and creating a draft proposal for the upcoming year's membership
registration fee.

<h4>9. Rules for the Elections and Vote</h4>
Voting is kept closed with the use of ballots if an official member suggests so. Elections are
always closed ballot elections using a single transferable vote system.
The single transferable vote system must be transparent and explicit to all attending official
members.
In the case of a tie during an official statutory meeting, a lottery is made to resolve the tie.
In the case of a tie during a board meeting, the president decides the outcome. If the
president is not present, it will be the vice president who decides the outcome.

<h4>10. Changing the Rules of the Association</h4>
The rules of the association can be changed at an official meeting if 2/3 of the votes are in
favor of the rule changes. Members must be informed about the vote in the meeting
invitation. 

<h4>11. Dissolution of the Association</h4>
Two official meetings need to be held for the association to be dissolved. The dissolution of
the association requires 4/5 of the members votes for dissolution. The meeting invitation
must mention the vote for dissolution of the association.

<h4>12. The use of the funds of the association after dissolution </h4>
The funds of the association will be primarily donated to Limes ry. If the said organization
no longer exists, the board can choose where to donate the funds during the meeting where
the association is dissolved. The funds must be donated to a student association that is
based at the faculty of Science at University of Helsinki.
            </p>
                          
          </div>

        </div>
      </section>
    </div>
  );
};

export default RulesEN;

